// extracted by mini-css-extract-plugin
export default {"wrapper":"src-modules-page-blocks-HeaderSecondary-style__wrapper_8jlgA","subtitle":"src-modules-page-blocks-HeaderSecondary-style__subtitle_CzWKx"};